<template>
  <v-container>
    <h2 class="light-green--text">{{event.name}}</h2>
    <v-row class="my-1">
      <v-col>
        <v-row class="my-n4">
          <v-icon color="light-green">mdi-account</v-icon>
          <p>{{event.creator}}</p>
        </v-row>
        <v-row class="my-n4">
          <v-icon color="light-green">mdi-account-multiple</v-icon>
          <p>{{event.participants}} participants</p>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="my-n4">
      <v-icon color="light-green">mdi-calendar-blank-outline</v-icon>
      <p>{{event.time}}</p>
    </v-row>
    <v-row>
      <v-img :src="event.picId" height="50" style="my-1"></v-img>
    </v-row>
    <v-row class="d-flex justify-center">
      <v-btn color="light-green" class="mt-2" style="color:white" @click="$emit('joinEvent')">Join!</v-btn>
    </v-row>
  </v-container>
</template>

<script>
export default {
    name:'MapPopup',
    props: ['event'],
};
</script>

<style>
</style>